import BrandComponent from "../../mini_components/BrandComponent";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import Loader from "../../shared/Loader";

function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(true);

  const searchParams = new URLSearchParams(location.search);
  const adminToken = searchParams.get("adminToken") || "";
  useEffect(() => {
    if (adminToken) {
      Cookies.set("token", adminToken);
      navigate("/home");
    }

    setLoading(false);
  }, [adminToken]);
  if (loading) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <Loader />
      </div>
    );
  }

  return (
    <div className="h-dvh md:h-screen flex justify-center items-center bg-primary-50 md:p-4  ">
      <div className="flex flex-col justify-center items-center gap-4 bg-white md:rounded-3xl p-3 shadow-xl w-full h-full md:w-[560px]">
        <BrandComponent
          width={"170px"}
          height={"170px"}
          className={"flex-col md:flex-col mb-3"}
        />

        <img
          src="/images/vanda-wallet-text.png"
          alt=""
          className="text-[24px] font-bold h-10  "
        />

        <Outlet />
      </div>
    </div>
  );
}

export default Login;
